export function getRoleLabel(role: string | null | undefined): string {
  if (!role) {
    return '';
  }

  return role === 'User' ? 'Mitarbeiter' : role;
}
